<script>
export default {
  name: 'BoardPreloadMixin',
  methods: {
    async preload(preloadList) {
      await preloadList.forEach(async (item) => {
        const result = await this.$store.dispatch(item.target);
        this.loadList[item.name] = result;
      });

      this.preloadSuccess = true;
    },
  },
  async created() {
    await this.preload(this.config.preloadList);
  },
  computed: {
    isSuccessPreload() {
      return this.preloadSuccess;
    },
    preloadList() {
      return this.loadList;
    },
  },
  data() {
    return {
      loadList: {},
      preloadSuccess: false,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/table/components/mixins/BoardPreloadMixin.vue